import React from 'react';
import ConfigSummary from './ConfigSummary';
import ConfigHeader from './ConfigHeader';
import { Retry } from '@components/common';

export default function AlertsConfig({ isConfigLoading }) {
  if (isConfigLoading) {
    <Retry isLoading={isConfigLoading} />;
  }

  return (
    <>
      <ConfigHeader />
      <ConfigSummary />
    </>
  );
}
